module.exports = __webpack_public_path__ + "static/img/8.2e0e09e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/8.png
// module id = lXeZ
// module chunks = 0